(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score-parts/event-row-outcomes.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score-parts/event-row-outcomes.js');
"use strict";


const productIds = svs.utils.products.productIds;
const OutcomePair = svs.components.lbUi.OutcomePair;
const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableHead = _svs$ui$reactTable.TableHead,
  TableBody = _svs$ui$reactTable.TableBody,
  TableRow = _svs$ui$reactTable.TableRow,
  TableCell = _svs$ui$reactTable.TableCell,
  TableHeader = _svs$ui$reactTable.TableHeader;
const EventRowOutcomes = _ref => {
  let eventIndex = _ref.eventIndex,
    productId = _ref.productId,
    isPixMix = _ref.isPixMix;
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  }); 
  const pixData = pixHandler.getModel(productId);
  let eventResults = {};
  if (productId === productIds.BOMBEN || productId === productIds.MATCHEN) {
    eventResults = (pixData === null || pixData === void 0 ? void 0 : pixData[eventIndex]) || [];
  }
  let maxCountOfResults = 0;
  if (eventResults) {
    const homeWinResults = eventResults.homeWin || [];
    const drawResults = eventResults.draw || [];
    const awayWinResults = eventResults.awayWin || [];
    maxCountOfResults = Math.max(homeWinResults.length, drawResults.length, awayWinResults.length);
  }
  const allEventResults = [];
  for (let i = 0; i < maxCountOfResults; i++) {
    var _eventResults$homeWin, _eventResults$draw, _eventResults$awayWin;
    allEventResults.push({
      homeWin: (_eventResults$homeWin = eventResults.homeWin) === null || _eventResults$homeWin === void 0 ? void 0 : _eventResults$homeWin[i],
      draw: (_eventResults$draw = eventResults.draw) === null || _eventResults$draw === void 0 ? void 0 : _eventResults$draw[i],
      awayWin: (_eventResults$awayWin = eventResults.awayWin) === null || _eventResults$awayWin === void 0 ? void 0 : _eventResults$awayWin[i]
    });
  }
  return React.createElement("div", {
    className: "coupon-score-outcomes",
    "data-testid": "event-".concat(eventIndex, "-outcomes")
  }, React.createElement(Table, {
    "aria-label": "Resultat",
    className: "coupon-score-table",
    inverted: true,
    role: "table"
  }, React.createElement(TableHead, null, React.createElement(TableRow, {
    className: "u-flex u-flex-justify-content-between"
  }, React.createElement(TableHeader, {
    className: "coupon-score-table-outcome outcome-home"
  }, React.createElement("p", {
    className: "margin-bottom-0 fc-white"
  }, "Hemmavinst")), React.createElement(TableHeader, {
    className: "coupon-score-table-outcome outcome-draw"
  }, React.createElement("p", {
    className: "margin-bottom-0 fc-white"
  }, "Oavgjort")), React.createElement(TableHeader, {
    className: "coupon-score-table-outcome outcome-away"
  }, React.createElement("p", {
    className: "margin-bottom-0 fc-white"
  }, "Bortavinst")))), React.createElement(TableBody, null, allEventResults === null || allEventResults === void 0 ? void 0 : allEventResults.map(eventResult => {
    const key = "".concat(eventIndex, "_").concat(eventResult.homeWin, "_").concat(eventResult.draw, "_").concat(eventResult.awayWin);
    return React.createElement(TableRow, {
      className: "u-flex u-flex-justify-content-between coupon-score-table-row",
      key: key
    }, React.createElement(TableCell, {
      "aria-label": "Hemmavinst",
      className: "coupon-score-table-outcome outcome-home"
    }, eventResult.homeWin && React.createElement(OutcomePair, {
      outcomeAway: eventResult.homeWin[1],
      outcomeHome: eventResult.homeWin[0]
    })), React.createElement(TableCell, {
      "aria-label": "Oavgjort",
      className: "coupon-score-table-outcome outcome-draw"
    }, eventResult.draw && React.createElement(OutcomePair, {
      outcomeAway: eventResult.draw[1],
      outcomeHome: eventResult.draw[0]
    })), React.createElement(TableCell, {
      "aria-label": "Bortavinst",
      className: "coupon-score-table-outcome outcome-away"
    }, eventResult.awayWin && React.createElement(OutcomePair, {
      outcomeAway: eventResult.awayWin[1],
      outcomeHome: eventResult.awayWin[0]
    })));
  }))));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponScoreParts.EventRowOutcomes', EventRowOutcomes);

 })(window);